import {USER_PERSIST_OPTIONAL_KEY} from './constants';
import {useLocalStorage} from '@aboutyou/storage';
import {OptionalUserState} from './types';

export const useOptionalUser = () => {
  const [optionalUser, setOptionalUser] = useLocalStorage<OptionalUserState>({
    key: USER_PERSIST_OPTIONAL_KEY,
    defaultValue: {userData: null},
  });

  const saveData = (data: any) => {
    if (data && !data.userData) {
      setOptionalUser(undefined);
      return;
    }

    setOptionalUser(data);
  };

  return {data: optionalUser, updateCache: saveData};
};
